import { useEffect } from 'react';

import { useUserAtom } from '@/entities/auth/atoms/user-atom';
import { useWorkspace } from '../hooks/use-workspace';
import { initTrack } from './index';

export const useTrack = () => {
  const user = useUserAtom();
  const { workspace } = useWorkspace();

  useEffect(() => {
    if (user && workspace) {
      initTrack(user, workspace);
    }
  }, [user, workspace]);
};
